import './Footer.css';
import { HashLink } from 'react-router-hash-link';

// import Logo from "./Logo.PNG";


export default function Foot() {

   const handleClick = () => {
    window.location.href = 'https://www.instagram.com/poolguy.on?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';
   } 

   const handleClickFacebook = () => {
    window.location.href = 'https://www.facebook.com/share/1ESiCxHV6e/?mibextid=wwXIfr';
   } 

    return <footer>
        <div className='cont-foot'>
            <div className='block-foot'>
                <h3>Connect with Us</h3>
                <p onClick={handleClick}>Instagram</p>
                <p onClick={handleClickFacebook }>Facebook</p>
            </div>  
            <div className='block-foot'>
                <h3>Quick Links</h3>
                <HashLink to="/#home">Home</HashLink>
                <HashLink to="/#serviec">Services</HashLink>
                <HashLink to="/about">About</HashLink>
                <HashLink to="/#faq">FAQ</HashLink>
                <HashLink to="/#contact">Contact</HashLink>
            </div>
            <div className='block-foot'>
                <h3>Contact Us</h3>
                <p>Reach Support</p>
                <p>Email: landscapeking2015@gmail.com</p>
                <p>Serving Hamilton area, including Burlington, Oakville, and Brantford.</p>
            </div>
        </div>
        <div className='div-rights'><p>© Creatica 2024. All rights reserved.</p></div>
    </footer>
}